import React from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as WhatsAppIcon } from 'src/image/common/whatsapp.svg';
import { ReactComponent as LineIcon } from 'src/image/common/line.svg';
import { ReactComponent as Chat } from 'src/image/common/chat.svg';
import { LocalizedLink } from 'src/components/common/LocalizedLink';

interface FooterPanelProps {
  isVisible: boolean;
}

export const FooterPanel: React.FC<FooterPanelProps> = ({ isVisible }) => {
  // URL から言語を判定
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  // 非表示の場合はレンダーしない
  if (!isVisible) {
    return null;
  }

  return (
    <div className="relative w-full mt-4 md:hidden">
      <LocalizedLink to="/inquiry">
        <div
          className="
            cursor-pointer
            border
            bg-whiteYellow
            w-16
            h-16
            flex
            flex-col
            items-center
            justify-center
            ml-[25px]
            gap-y-0      /* 子要素間の縦ギャップを 0 に */
          "
        >
          <Chat className="w-6 h-6" />
          <span
            className="
              text-[8px]
              m-0           /* マージンをリセット */
              mt-1           /* マージンをリセット */
              p-0           /* パディングをリセット */
              leading-none  /* 行間を詰める */
            "
          >
            contact
          </span>
        </div>
      </LocalizedLink>
    </div>
  );
};

export default FooterPanel;
